import { FC } from "react";
import { KTIcon } from "../../../../../../_metronic/helpers";

interface Props {
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ShareDealModalHeader: FC<Props> = ({ setIsOpenModal }) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <h2 className="fw-bolder mb-0">Поделиться сделкой</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-primary btn-active-icon-light"
        data-kt-users-modal-action="close"
        onClick={() => {
          setIsOpenModal(false);
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};
